/** Port of app/lib/appreciation.py. */

export interface Appreciator {
    appreciation_rate: number;
    appreciate(principal: number, months: number): number;
}

export function appreciator(appreciation_rate: number): Appreciator {
    return {
        appreciation_rate,
        appreciate(principal: number, months: number) {
            const years = months / 12;
            return principal * (1 + appreciation_rate) ** years;
        },
    };
}
